import React,{ useState, useEffect } from 'react'
import './FormConfiguration.css'
import mainLogo from "./../../../../assets/global_assets/assignClients/mainIcon.png"
import { getAllUnits } from "./../../../../services/global_redux/globale_actions/Unit.action"
import { getCompanyDetails ,updateCompanyDetailsById } from "./../../../../services/global_redux/globale_actions/CompanyDetails.action"
import { useDispatch } from "react-redux";
import { cache } from 'react'

function FormConfiguration({ showSnackbar, setLoading }) {
    const [searchQuery, setSearchQuery] = useState("");
    const dispatch = useDispatch();
    const [clientAndUnit, setClientAndUnit] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [totalOrgToAccess, setTotalOrgToAccess] = useState(0);
    const [totalBranchToAccess, setTotalBranchToAccess] = useState(0);
    const [companyData, setCompanyData] = useState([]);
  
    const use_company_code = JSON.parse(sessionStorage.getItem("user"));
    const CompanyID = use_company_code?.company_code;
  
    const fetchCompanyDetails = async () => {
      try {
        setLoading(true);
        const response = await dispatch(getCompanyDetails(CompanyID));
  
        if (response.success) {
            setCompanyData(response.data);
          setTotalOrgToAccess(response.data.total_clients || 0);
          setTotalBranchToAccess(response.data.total_units || 0);
          if (response.data.client_unit_assignment) {
            const preselectedOrgs = response.data.client_unit_assignment.map(
              (item) => item.client_id
            );
            const preselectedBranches = response.data.client_unit_assignment.flatMap(
              (item) => item.unit_id
            );
            setSelectedOrgs(preselectedOrgs);
            setSelectedBranches(preselectedBranches);
          }
        } else {
          setTotalOrgToAccess(0);
          setTotalBranchToAccess(0);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
        setTotalOrgToAccess(0);
        setTotalBranchToAccess(0);
      } finally {
        setLoading(false);
      }
    };
  
    const fetchClientAndUnit = async () => {
      try {
        const response = await dispatch(getAllUnits());
        if (response.data?.client_and_unit) {
          setClientAndUnit(response.data.client_and_unit);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
  
    useEffect(() => {
      fetchClientAndUnit();
      fetchCompanyDetails();
    }, [dispatch]);
  
    const handleOrgCheck = (client) => {
      const alreadySelected = selectedOrgs.includes(client.client_id);
      let newSelectedOrgs = [...selectedOrgs];
      let newSelectedBranches = [...selectedBranches];
  
      if (alreadySelected) {
        newSelectedOrgs = newSelectedOrgs.filter(
          (id) => id !== client.client_id
        );
        newSelectedBranches = newSelectedBranches.filter(
          (id) => !client.unit_id.includes(id)
        );
      } else {
        if (selectedOrgs.length < totalOrgToAccess) {
          newSelectedOrgs.push(client.client_id);
        }
      }
  
      setSelectedOrgs(newSelectedOrgs);
      setSelectedBranches(newSelectedBranches);
    };
  
    const handleBranchCheck = (client, branchId) => {
      const alreadySelected = selectedBranches.includes(branchId);
      let newSelectedBranches = [...selectedBranches];
  
      if (alreadySelected) {
        newSelectedBranches = newSelectedBranches.filter((id) => id !== branchId);
      } else {
        if (selectedBranches.length < totalBranchToAccess) {
          newSelectedBranches.push(branchId);
        }
      }
  
      setSelectedBranches(newSelectedBranches);
    };
  
    const isOrgDisabled =
      selectedOrgs.length >= totalOrgToAccess &&
      selectedOrgs.length !== 0;
  
    const isBranchDisabled =
      selectedBranches.length >= totalBranchToAccess &&
      selectedBranches.length !== 0;
  
    const handleSubmit = () => {
      const selectedData = clientAndUnit
        .filter((client) => selectedOrgs.includes(client.client_id))
        .map((client) => ({
          client_id: client.client_id,
          unit_id: client.unit_id.filter((u) => selectedBranches.includes(u)),
        }))
        .filter((item) => item.unit_id.length > 0);
        const finalData = {
            ...companyData,
            client_unit_assignment :selectedData
        }
        updateCompanyDetails(finalData.id,finalData)
    };
    const updateCompanyDetails = async (id,data)=>{
        setLoading(true);
        try{
            const response = await dispatch(updateCompanyDetailsById(id, data));
            if(response.success){
                setLoading(false);
                showSnackbar('Updated Successfully')
            }else{
                setLoading(false);
                showSnackbar('Something went wrong')
            }
        }catch(err){
            setLoading(false);
            console.error("Update error:", err);

        }
    }
    const filteredData = clientAndUnit
    ? clientAndUnit.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    ): [];
  return (
    <div className="contaner-fluid m-0">
      <div className="col-md-12 assign-permission-main-container">
        <div className="row ">
          <div className="col-md-12">
            <div className="mainTitle d-flex justify-content-between">
              <h5  className="text-dark">Select Organization For Generating Forms</h5>

            </div>
          </div>
        </div>
        <div className="row assign-permission-table-container">
            <div className="form-assignment-sub-header d-flex justify-content-between">
            <div className="title-header d-flex">
                <div className="logoicon">
                <img src={mainLogo} alt="" />
                </div>
                <h5>Form Configuration</h5>
            </div>
            <div className="FormsTable-search-box position-relative">
                <input
                type="text"
                className=""
                placeholder="Search here..."
                style={{
                    backgroundColor: "#f9fafb",
                    border: "none",
                    width: "200px"
                }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                />
                <i
                className="bi bi-search position-absolute"
                style={{
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#9ca3af"
                }}
                ></i>
            </div>
                
            </div>
            <div className="form-assignment-sub-header d-flex justify-content-start">
              
                <div className=" d-flex form-assignment-sub-header-data ">
                    <button className='btn btn-sm btn-primatry'>Total Orgs Allowed : {totalOrgToAccess} </button>
                </div>
                <div className="d-flex form-assignment-sub-header-data ">
                    <button className='btn btn-sm btn-primatry'>Total Branches Allowed : {totalBranchToAccess} </button>
                </div>
                <div className="d-flex form-assignment-sub-header-data ">
                    <button className='btn btn-sm btn-primatry'>Orgs Selected : {selectedOrgs.length} </button>
                </div>
                <div className="d-flex form-assignment-sub-header-data ">
                    <button className='btn btn-sm btn-primatry'>Branches Selected : {selectedBranches.length} </button>
                </div>
            </div>
        <div className="table-responsive form-assignment-table-height p-0 m-0">
          <table className='table'>
            <thead className=''>
              <tr>
                <th className='slno'>
                </th>
                <th>Organization and Branch Name</th>
                <th>Organization and Branch ID</th>
              </tr>
            </thead>
            <tbody>
            {filteredData.map((client) => (
                <React.Fragment key={client.client_id}>
                  <tr className="table-secondary">
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedOrgs.includes(client.client_id)}
                        onChange={() => handleOrgCheck(client)}
                        disabled={
                          !selectedOrgs.includes(client.client_id) &&
                          isOrgDisabled
                        }
                      />
                    </td>
                    <td>
                      {client.client_name}
                    </td>
                    <td>{client.client_id}</td>
                  </tr>

                  {client.unit_names.map((branchName, i) => (
                    <tr key={client.unit_id[i]} className="bg-light">
                      <td className="ps-4">
                        <input
                          type="checkbox"
                          checked={selectedBranches.includes(
                            client.unit_id[i]
                          )}
                          onChange={() =>
                            handleBranchCheck(client, client.unit_id[i])
                          }
                          disabled={
                            !selectedOrgs.includes(client.client_id) ||
                            (!selectedBranches.includes(client.unit_id[i]) && isBranchDisabled)
                          }                          
                        />
                      </td>
                      <td className="ps-5">{branchName}</td>
                      <td>{client.unit_id[i]}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-end mt-3">
          <button
            className="btn btn-primary px-4 mb-4"
            onClick={handleSubmit}
            disabled={selectedBranches.length === 0}
          >
            Submit
          </button>
        </div>
        </div>
      </div>
    </div>
  )
}

export default FormConfiguration